import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.contentElement = document.getElementById('content-container')

    if (this.contentElement) {
      this.syncHeight()
      this.setupResizeObserver()
      this.setupStreamListener()
    }
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    if (this.streamListener) {
      document.removeEventListener('turbo:before-stream-render', this.streamListener)
    }
  }

  syncHeight = () => {
    const height = this.contentElement.offsetHeight
    this.element.style.height = `${height}px`
  }

  setupResizeObserver = () => {
    this.resizeObserver = new ResizeObserver(() => {
      this.syncHeight()
    })
    this.resizeObserver.observe(this.contentElement)
  }

  setupStreamListener = () => {
    this.streamListener = (event) => {
      const originalRender = event.detail.render
      event.detail.render = async (currentElement) => {
        await originalRender(currentElement)
        this.syncHeight()
      }
    }
    document.addEventListener('turbo:before-stream-render', this.streamListener)
  }
}
